import axios from 'axios';
import authHeader from './auth-header';
import config from  '../config/config'

class DataService {
  
  getPayload() {

//     return new Promise((resolve, reject) => {
//       setTimeout(()=> {
//         resolve({
//           status: 200,
//           data: {
//             "firstName": "Neimun",
//             "lastName": "Margus",
//             "billingAddress1": "123 Test Street",
//             "billingAddress2": "Suite 102",
//             "billingCity": "Dallas",
//             "billingState": "TX",
//             "billingCountry": "US",
//             "billingPostalCode": "75211",
//             "orderNumber": "INV-123456",
//             "storeNumber": "NM-300063",
//             "paymentDueDateGMT": "1645660800",
//             "paymentExpirationGMT": "1645660800",
//             "customerEmail": "john.doe@gmail.com",
//             "customerPhone": "15145551222",
//             "customerNum": "CL21012468327",
//             "lineItems": {
//                 "1": {
//                     "fsaNo": "WO12345677",
//                     "sku": "GM21012410002",
//                     "description": "Fur Storage",
//                     "itemDescription": "PASTEL & WHITE MINK 3/4 COAT W/OPOSSUM COLLAR",
//                     "amount": "100.00",
//                     "tax": "12.50",
//                     "optional": [
//                         {
//                             "sku": "12345",
//                             "description": "Cleaning",
//                             "amount": "15",
//                             "taxes": "1.50"
//                         },
//                         {
//                             "sku": "12346",
//                             "description": "Repairs",
//                             "amount": "25",
//                             "taxes": "2.50"
//                         }
//                     ]
//                 },
//                 "2": {
//                   "fsaNo": "WO12345677",
//                   "sku": "GM21012410002",
//                   "description": "Fur Storage",
//                   "itemDescription": "PASTEL & WHITE MINK 3/4 COAT W/OPOSSUM COLLAR",
//                   "amount": "100.00",
//                   "tax": "12.50",
//                   "optional": [
//                       {
//                           "sku": "12345",
//                           "description": "Cleaning",
//                           "amount": "15",
//                           "taxes": "1.50"
//                       },
//                       {
//                           "sku": "12346",
//                           "description": "Repairs",
//                           "amount": "25",
//                           "taxes": "2.50"
//                       }
//                   ]
//                 },
//                 "3": {
//                   "fsaNo": "WO12345677",
//                   "sku": "GM21012410002",
//                   "description": "Fur Storage",
//                   "itemDescription": "PASTEL & WHITE MINK 3/4 COAT W/OPOSSUM COLLAR",
//                   "amount": "100.00",
//                   "tax": "12.50",
//                   "optional": [
//                       {
//                           "sku": "12345",
//                           "description": "Cleaning",
//                           "amount": "15",
//                           "taxes": "1.50"
//                       },
//                       {
//                           "sku": "12346",
//                           "description": "Repairs",
//                           "amount": "25",
//                           "taxes": "2.50"
//                       }
//                   ]
//               },
//               "4": {
//                 "fsaNo": "WO12345677",
//                 "sku": "GM21012410002",
//                 "description": "Fur Storage",
//                 "itemDescription": "PASTEL & WHITE MINK 3/4 COAT W/OPOSSUM COLLAR",
//                 "amount": "100.00",
//                 "tax": "12.50",
//                 "optional": [
//                     {
//                         "sku": "12345",
//                         "description": "Cleaning",
//                         "amount": "15",
//                         "taxes": "1.50"
//                     },
//                     {
//                         "sku": "12346",
//                         "description": "Repairs",
//                         "amount": "25",
//                         "taxes": "2.50"
//                     }
//                 ]
//             },
//             "5": {
//               "fsaNo": "WO12345677",
//               "sku": "GM21012410002",
//               "description": "Fur Storage",
//               "itemDescription": "PASTEL & WHITE MINK 3/4 COAT W/OPOSSUM COLLAR",
//               "amount": "100.00",
//               "tax": "12.50",
//               "optional": [
//                   {
//                       "sku": "12345",
//                       "description": "Cleaning",
//                       "amount": "15",
//                       "taxes": "1.50"
//                   },
//                   {
//                       "sku": "12346",
//                       "description": "Repairs",
//                       "amount": "25",
//                       "taxes": "2.50"
//                   }
//               ]
//           },
//           "6": {
//             "fsaNo": "WO12345677",
//             "sku": "GM21012410002",
//             "description": "Fur Storage",
//             "itemDescription": "PASTEL & WHITE MINK 3/4 COAT W/OPOSSUM COLLAR",
//             "amount": "100.00",
//             "tax": "12.50",
//             "optional": [
//                 {
//                     "sku": "12345",
//                     "description": "Cleaning",
//                     "amount": "15",
//                     "taxes": "1.50"
//                 },
//                 {
//                     "sku": "12346",
//                     "description": "Repairs",
//                     "amount": "25",
//                     "taxes": "2.50"
//                 }
//             ]
//         },
//         "7": {
//           "fsaNo": "WO12345677",
//           "sku": "GM21012410002",
//           "description": "Fur Storage",
//           "itemDescription": "PASTEL & WHITE MINK 3/4 COAT W/OPOSSUM COLLAR",
//           "amount": "100.00",
//           "tax": "12.50",
//           "optional": [
//               {
//                   "sku": "12345",
//                   "description": "Cleaning",
//                   "amount": "15",
//                   "taxes": "1.50"
//               },
//               {
//                   "sku": "12346",
//                   "description": "Repairs",
//                   "amount": "25",
//                   "taxes": "2.50"
//               }
//           ]
//       },
//       "8": {
//         "fsaNo": "WO12345677",
//         "sku": "GM21012410002",
//         "description": "Fur Storage",
//         "itemDescription": "PASTEL & WHITE MINK 3/4 COAT W/OPOSSUM COLLAR",
//         "amount": "100.00",
//         "tax": "12.50",
//         "optional": [
//             {
//                 "sku": "12345",
//                 "description": "Cleaning",
//                 "amount": "15",
//                 "taxes": "1.50"
//             },
//             {
//                 "sku": "12346",
//                 "description": "Repairs",
//                 "amount": "25",
//                 "taxes": "2.50"
//             }
//         ]
//     },
//     "9": {
//       "fsaNo": "WO12345677",
//       "sku": "GM21012410002",
//       "description": "Fur Storage",
//       "itemDescription": "PASTEL & WHITE MINK 3/4 COAT W/OPOSSUM COLLAR",
//       "amount": "100.00",
//       "tax": "12.50",
//       "optional": [
//           {
//               "sku": "12345",
//               "description": "Cleaning",
//               "amount": "15",
//               "taxes": "1.50"
//           },
//           {
//               "sku": "12346",
//               "description": "Repairs",
//               "amount": "25",
//               "taxes": "2.50"
//           }
//       ]
//   },
//   "10": {
//     "fsaNo": "WO12345677",
//     "sku": "GM21012410002",
//     "description": "Fur Storage",
//     "itemDescription": "PASTEL & WHITE MINK 3/4 COAT W/OPOSSUM COLLAR",
//     "amount": "100.00",
//     "tax": "12.50",
//     "optional": [
//         {
//             "sku": "12345",
//             "description": "Cleaning",
//             "amount": "15",
//             "taxes": "1.50"
//         },
//         {
//             "sku": "12346",
//             "description": "Repairs",
//             "amount": "25",
//             "taxes": "2.50"
//         }
//     ]
// },
// "11": {
//   "fsaNo": "WO12345677",
//   "sku": "GM21012410002",
//   "description": "Fur Storage",
//   "itemDescription": "PASTEL & WHITE MINK 3/4 COAT W/OPOSSUM COLLAR",
//   "amount": "100.00",
//   "tax": "12.50",
//   "optional": [
//       {
//           "sku": "12345",
//           "description": "Cleaning",
//           "amount": "15",
//           "taxes": "1.50"
//       },
//       {
//           "sku": "12346",
//           "description": "Repairs",
//           "amount": "25",
//           "taxes": "2.50"
//       }
//   ]
// },
// "12": {
//   "fsaNo": "WO12345677",
//   "sku": "GM21012410002",
//   "description": "Fur Storage",
//   "itemDescription": "PASTEL & WHITE MINK 3/4 COAT W/OPOSSUM COLLAR",
//   "amount": "100.00",
//   "tax": "12.50",
//   "optional": [
//       {
//           "sku": "12345",
//           "description": "Cleaning",
//           "amount": "15",
//           "taxes": "1.50"
//       },
//       {
//           "sku": "12346",
//           "description": "Repairs",
//           "amount": "25",
//           "taxes": "2.50"
//       }
//   ]
// }
//             },
//             "iat": 1644984019,
//             "paid": false
//         }
//         });
//       }, 300);
//     });
    return axios.get(config.getApiDomain() + '/v1/info',{withCredentials:true});
  }
  getPaymenturl() {

    return axios.get(config.getApiDomain() + '/payment/v1/url',{withCredentials:true});
  }
  post_payment_succees_call(postdata)
  {
    return axios.post(config.getApiDomain() + '/payment/v1/process', postdata,{withCredentials:true})
  }
}
export default new DataService();